const CookiePolicy = () => (
  <div className="max-w-3xl mx-auto px-6 py-12 text-gray-700">
    <h1 className="text-3xl font-bold mb-2 text-purple-700">Cookie Policy</h1>
    <p className="text-sm text-gray-400 mb-8">Last updated: May 2026</p>

    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-3 text-gray-800">What are cookies?</h2>
      <p className="leading-relaxed">
        Cookies are small text files stored on your device when you visit a website.
        We use them to keep you logged in, remember preferences, and understand how the site is used.
      </p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-3 text-gray-800">Cookies we use</h2>
      <div className="overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="bg-purple-50">
              <th className="text-left p-3 border border-purple-100 font-semibold text-gray-700">Category</th>
              <th className="text-left p-3 border border-purple-100 font-semibold text-gray-700">Purpose</th>
              <th className="text-left p-3 border border-purple-100 font-semibold text-gray-700">Can be declined?</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="p-3 border border-gray-100 font-medium">Essential</td>
              <td className="p-3 border border-gray-100">Authentication session, CSRF protection</td>
              <td className="p-3 border border-gray-100">No</td>
            </tr>
            <tr className="bg-gray-50">
              <td className="p-3 border border-gray-100 font-medium">Analytics</td>
              <td className="p-3 border border-gray-100">Google Analytics — anonymised page-view tracking</td>
              <td className="p-3 border border-gray-100">Yes</td>
            </tr>
            <tr>
              <td className="p-3 border border-gray-100 font-medium">Preferences</td>
              <td className="p-3 border border-gray-100">Cookie consent choice (<code>sa_cookie_consent</code>)</td>
              <td className="p-3 border border-gray-100">No</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-3 text-gray-800">Managing cookies</h2>
      <p className="leading-relaxed">
        You can change your consent at any time by clearing <code>sa_cookie_consent</code> from localStorage
        and reloading the page. You can also manage or block cookies via your browser settings.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold mb-3 text-gray-800">Contact</h2>
      <p className="leading-relaxed">
        <a href="mailto:contact@stray-apps.com" className="text-purple-600 hover:underline">contact@stray-apps.com</a>
      </p>
    </section>
  </div>
);

export default CookiePolicy;
